// Central registry of module IDs used across the sidebar (Layout.jsx) and the
// user permissions editor (Settings). Matches the `id` prop on each nav item.
// If an empty list is stored on a user's `visible_modules`, they see everything
// that their role allows (default behaviour, no restriction).

export const MODULE_GROUPS = [
  {
    label: "Núcleo",
    modules: [
      { id: "dashboard", label: "Panel de Control" },
      { id: "address-book", label: "Libreta de Direcciones" },
      { id: "items", label: "Maestro de Artículos" },
      { id: "classifications", label: "Clasificaciones" },
      { id: "equipment", label: "Equipos" },
      { id: "cardex", label: "Cardex de Inventario" },
      { id: "stock-rotation", label: "Rotación de Existencias" },
    ],
  },
  {
    label: "Almacén (WMS)",
    modules: [
      { id: "locations", label: "Ubicaciones" },
      { id: "transfers", label: "Transferencias" },
      { id: "vales", label: "Vales de Salida" },
      { id: "cycle-counts", label: "Conteos Cíclicos" },
      { id: "quarantine", label: "Cuarentena / Calidad" },
      { id: "pick-pack", label: "Pick / Pack / Ship" },
      { id: "serials", label: "Números de Serie" },
      { id: "scanner", label: "Escáner (Móvil)" },
    ],
  },
  {
    label: "Compras",
    modules: [
      { id: "requisitions", label: "Requisiciones" },
      { id: "purchase-orders", label: "Órdenes de Compra" },
      { id: "receipts", label: "Recepciones" },
      { id: "match", label: "Conciliación 3 Vías" },
      { id: "mrp", label: "MRP / Reabastecimiento" },
      { id: "reabasto", label: "Panel de Reabasto" },
      { id: "internal-requisitions", label: "Requisiciones Internas" },
    ],
  },
  {
    label: "Mantenimiento",
    modules: [
      { id: "mnt-dashboard", label: "Panel Mantenimiento" },
      { id: "mnt-dispatch", label: "Dispatch de Flotilla" },
      { id: "mnt-alerts", label: "Avisos" },
      { id: "mnt-work-orders", label: "Órdenes de Trabajo" },
      { id: "mnt-technicians", label: "Mecánicos" },
      { id: "mnt-meters", label: "Puntos de Medición" },
      { id: "mnt-history", label: "Historial de OT" },
      { id: "mnt-consumption", label: "Consumo por Área" },
    ],
  },
  {
    label: "Sistema",
    modules: [
      { id: "inbox", label: "Mi Escritorio" },
      { id: "personnel", label: "Personal del Proyecto" },
      { id: "departments", label: "Departamentos" },
      { id: "accounting", label: "Plan de Cuentas" },
      { id: "acc-reports", label: "Finanzas por Contrato" },
      { id: "onboarding", label: "Arranque e Importación" },
      { id: "settings", label: "Ajustes" },
    ],
  },
];

export const ALL_MODULE_IDS = MODULE_GROUPS.flatMap((g) => g.modules.map((m) => m.id));
